import { useMemo } from "react";

import { Accordion, Subsection } from "components/layout";
import {
  CONTINENT_WORLD,
  getContinentNames,
  getCountries,
  getCountriesForContinent,
} from "utils/continents";

import { TEXTS } from "../constants";
import styles from "./Countries.scss";

export type CountriesProps = {
  countries: string[];
};

export function Countries({ countries: selectedCountries }: CountriesProps) {
  const continents = useMemo(
    () =>
      getContinentNames().map((name) => {
        const all = getCountriesForContinent(getCountries(), name);
        const selected = all
          .filter(({ code }) => selectedCountries.includes(code))
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        return {
          name,
          countries: {
            all,
            selected,
          },
        };
      }),
    [selectedCountries]
  );

  return continents.map(({ name, countries }) => {
    const { all, selected } = countries;

    const headerBracket =
      selected.length === all.length
        ? TEXTS.SHARED.ALL_COUNTRIES_LABEL
        : `${selected.length}/${all.length}`;
    const header = `${name} (${headerBracket})`;

    return (
      <Subsection key={name}>
        <Accordion
          disabled={selected.length === 0}
          header={header}
          headerType="compact"
          longContent={name === CONTINENT_WORLD}
        >
          <ul className={styles.continent}>
            {selected.map((country) => (
              <li key={country.code}>{country.name}</li>
            ))}
          </ul>
        </Accordion>
      </Subsection>
    );
  });
}
